import { render, staticRenderFns } from "./popovers.vue?vue&type=template&id=02b7c095&"
import script from "./popovers.vue?vue&type=script&lang=js&"
export * from "./popovers.vue?vue&type=script&lang=js&"
import style0 from "./popovers.vue?vue&type=style&index=0&id=02b7c095&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports